import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import globalContext from '../../config/context';
import '../Maps/Maps.css';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import {LayersControl, Map, TileLayer, GeoJSON, ZoomControl, ScaleControl, FeatureGroup} from 'react-leaflet';
import {EditControl} from 'react-leaflet-draw';
import {BingLayer} from 'react-leaflet-bing-v2';
import MaskedInput from 'react-text-mask';

//material-ui core
import Paper from '@material-ui/core/Paper/Paper';
import Tooltip from '@material-ui/core/Tooltip/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import {Box, Divider} from '@material-ui/core';
import InputBase from '@material-ui/core/InputBase/InputBase';
import Button from '@material-ui/core/Button';
import Grow from '@material-ui/core/Grow';

//material-ui Icons
import AddCircleIcon from '@material-ui/icons/AddCircle';
import HomeIcon from '@material-ui/icons/Home';
import SaveIcon from '@material-ui/icons/Save';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import FilterListIcon from '@material-ui/icons/FilterList';

//import others

const useStyles = makeStyles((theme) => ({
  //custom
  custom: {
    position: 'absolute',
    left: 0,
    top: 0,
  },
  filterList: {
    padding: '2px 4px',
    top: 10,
    left: 10,
    display: 'flex',
    alignItems: 'center',
    width: 400,
    position: 'relative',
    borderRadius: 9,
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },

  customIcon: {
    top: 20,
    left: 5,
    position: 'relative',
    display: 'block',
    width: 130,
  },
  customButton: {
    margin: theme.spacing(1),
  },
}));

const TextMaskCustom = (props) => {
  const {inputRef, ...other} = props;
  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      // kd_prov.kd_kabupaten.kd_kec.kd_kel.kd_blok.no_urut.kd_jns
      mask={[
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
      ]}
      placeholderChar={'_'}
    />
  );
};

const LeafletDraw = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [{pencarian, checkedBphtb}, {setPencarian, setAlert, setLoading}] = useAppContext();
  const {mapRef, baseLayerChange, zoomEnd, dragEnd, checked} = props;

  const state = {
    lat: -2.4806,
    lng: 112.936,
    zoom: 12,
  };

  const {BaseLayer} = LayersControl;
  const bing_key = 'AuhiCJHlGzhg93IqUH_oCpl_-ZUrIE6SPftlyGYUvr9Amx5nzA-WqGcPquyFZl4L';
  const position = [state.lat, state.lng];

  //custom
  const [checkedFilter, setCheckedFilter] = React.useState(false);

  const handleFilter = () => {
    setCheckedFilter((prev) => !prev);
  };

  return (
    <div className={classes.body}>
      <div className={classes.map}>
        <Map
          ref={mapRef}
          className="map"
          center={position}
          zoom={state.zoom}
          zoomControl={false}
          onBaseLayerChange={baseLayerChange}
          onZoomEnd={zoomEnd}
          onDragEnd={dragEnd}>
          <LayersControl position="topright">
            <BaseLayer checked name="Open Street Maps">
              <TileLayer
                attribution='<a href="http://citracom.co.id/" target="blank">PT.Citracom Inti Persada</a> &copy; <a href="https://www.openstreetmap.org/" target="blank">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
            </BaseLayer>
            <BaseLayer name="Google Maps">
              <TileLayer
                attribution='<a href="http://citracom.co.id/" target="blank">PT.Citracom Inti Persada</a> &copy; <a href="https://maps.google.com/" target="blank">GoogleMaps</a> contributors'
                url="https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
              />
            </BaseLayer>
            <BaseLayer name="Bing Maps">
              <BingLayer bingkey={bing_key} />
            </BaseLayer>
            <BaseLayer name="Google Satelite">
              <TileLayer
                attribution='<a href="http://citracom.co.id/" target="blank">PT.Citracom Inti Persada</a> &copy; <a href="https://maps.google.com/" target="blank">GoogleMaps</a> contributors'
                url="https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
              />
            </BaseLayer>
          </LayersControl>
          <ZoomControl position="topright" />
          {checked ? null : <ScaleControl />}

          <FeatureGroup>
            <EditControl
              position="topright"
              // onEdited={this._onEdited}
              // onCreated={this._onCreated}
              // onDeleted={this._onDeleted}
              // onMounted={this._onMounted}
              // onEditStart={this._onEditStart}
              // onEditStop={this._onEditStop}
              // onDeleteStart={this._onDeleteStart}
              // onDeleteStop={this._onDeleteStop}
              draw={{
                polyline: false,
                // polygon: false,
                rectangle: false,
                circle: false,
                marker: false,
                circlemarker: false,
              }}
              edit={
                {
                  // edit: false,
                  // remove: false,
                }
              }
            />
          </FeatureGroup>
        </Map>
      </div>

      {/* custom */}
      <div className={classes.custom + ' leaflet-control'}>
        {/*  text field */}
        <Paper component="div" className={classes.filterList}>
          <Tooltip title="Action" arrow>
            <IconButton className={classes.iconButton} aria-label="menu" onClick={handleFilter}>
              <FilterListIcon />
            </IconButton>
          </Tooltip>

          <InputBase
            value={null}
            onChange={null}
            className={classes.input}
            placeholder="Search NOP"
            inputComponent={TextMaskCustom}
            onKeyDown={null}
          />

          <Divider className={classes.divider} orientation="vertical" />
          <Tooltip title="back to Maps" arrow>
            <IconButton type="button" className={classes.iconButton} onClick={null} aria-label="home">
              <HomeIcon />
            </IconButton>
          </Tooltip>
        </Paper>

        {/*  add */}
        <div className={classes.customIcon}>
          <Grow in={checkedFilter}>
            <Button variant="contained" color="primary" className={classes.customButton} startIcon={<AddCircleIcon />}>
              Add
            </Button>
          </Grow>

          <Grow in={checkedFilter} style={{transformOrigin: '0 0 0'}} {...(checkedFilter ? {timeout: 1000} : {})}>
            <Button variant="contained" color="default" className={classes.customButton} startIcon={<SaveIcon />}>
              Edit
            </Button>
          </Grow>

          <Grow in={checkedFilter} style={{transformOrigin: '0 0 0'}} {...(checkedFilter ? {timeout: 2000} : {})}>
            <Button variant="contained" color="secondary" className={classes.customButton} startIcon={<DeleteForeverIcon />}>
              Delete
            </Button>
          </Grow>
        </div>
      </div>
    </div>
  );
};

export default LeafletDraw;
